//
// Module for the Tax Tables and Rates add new table view
//
rs.module("system_/configuration/taxtablesandrates/addnewtable",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, federalTaxType, taxTableDetailGrid) {

            // Unpack js Selectors
            var criteria = $.js(jsSelectors.criteria);

            var taxTypeSelect = criteria.js(jsSelectors.taxTypeSelect);
            var stateSelect = criteria.js(jsSelectors.stateSelect);
            var taxDetailGridError = criteria.js(jsSelectors.taxDetailGridError);
            var taxTableGridAddButton = criteria.js(jsSelectors.taxTableGridAddButton);

            // Get select helper(s)
            var stateSelectHelper = selectHelper.getHelper(stateSelect);

            // On tax type change, determine if the state drop down is still enabled.
            taxTypeSelect.change(function () {
                stateSelectHelper.setDisabled(taxTypeSelect.val() == federalTaxType);
                stateSelectHelper.setValue('');
            });

            // On tax table add button click, add a new row.
            taxTableGridAddButton.click(function () {

                eventBanner.removeAllMessages();
                taxDetailGridError.text('');
                taxTableDetailGrid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);